module.exports = __webpack_public_path__ + "resources/img/bg_cover_service_v2.b2673bdab682d6c3e7d813fc5056611d.png";